// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-descriptions .ant-descriptions-item-content {
    background-color: white;
  }
  
.ant-table-row.custom-row-hover:hover td {
  background-color: #e6f7ff !important; /* آبی ملایم */
  transition: background-color 0.3s ease;
}

.custom-select .ant-select-selection-placeholder {
  color: #4270b4 !important;
  font-weight: 500;
  text-shadow: 0.5px 0.5px #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/views/articleActions/css/ArticleActionsDetail.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;EACzB;;AAEF;EACE,oCAAoC,EAAE,cAAc;EACpD,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC","sourcesContent":[".custom-descriptions .ant-descriptions-item-content {\n    background-color: white;\n  }\n  \n.ant-table-row.custom-row-hover:hover td {\n  background-color: #e6f7ff !important; /* آبی ملایم */\n  transition: background-color 0.3s ease;\n}\n\n.custom-select .ant-select-selection-placeholder {\n  color: #4270b4 !important;\n  font-weight: 500;\n  text-shadow: 0.5px 0.5px #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
